import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilePickerComponent} from './file-picker.component';
import {DndModule} from 'ngx-drag-drop';
import {TranslocoModule} from '@ngneat/transloco';

@NgModule({
  declarations: [
    FilePickerComponent
  ],
  exports: [
    FilePickerComponent
  ],
  imports: [
    CommonModule,
    DndModule,
    TranslocoModule,
  ]
})
export class FilePickerModule { }
